const ConnectTool = () => import('./ConnectTool')
const NotFound = () => import('./NotFound')
const IntegrationBase = () => import('./IntegrationBase')
const ForgotPassword = () => import('./ForgotPassword/ForgotPassword.vue')

export default {
	path: '/connect',
	component: IntegrationBase,
	children: [
		{
			path: 'notFound',
			component: NotFound,
		},
		{
			path: ':integration/:step',
			component: ConnectTool,
		},
		{
			path: ':integration/forgotPassword/:step',
			component: ForgotPassword
		},


	]

}
